import classNames from 'classnames'

import style from './Tabs.module.scss'

interface IProps {
    currentTab: string
    tabs: string[]
    onSetTab: (tab: string) => void
}

export const Tabs = (props: IProps) => {
    const { tabs, onSetTab, currentTab } = props
    return (
        <div className={style.container}>
            {tabs.map((tab) => {
                const cn = classNames(style.tab, tab === currentTab && style.activeTab)
                return (
                    <div key={tab} className={cn} onClick={() => onSetTab(tab)}>
                        {tab}
                    </div>
                )
            })}
        </div>
    )
}
